import { LightningElement, api, wire } from "lwc";
import { gql, QueryAdapter } from "common/graphqlAdapter";
import { LabelsAdapter } from "common/labelsAdapter";
import { pluralizeLearningCollectionType } from "common/learning";

var data$9 = { title: "Details" };
data$9.title;

var data$8 = { title: "Details" };
data$8.title;

var data$7 = { title: "Detalles" };
data$7.title;

var data$6 = { title: "Detalles" };
data$6.title;

var data$5 = { title: "Détails" };
data$5.title;

var data$4 = { title: "Dettagli" };
data$4.title;

var data$3 = { title: "詳細" };
data$3.title;

var data$2 = { title: "세부 사항" };
data$2.title;

var data$1 = { title: "Detalhes" };
data$1.title;

var data = { title: "详细信息" };
data.title;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

class detailsModal extends LightningElement {
  @api config = null;
  @api open = false;
  @api summary = null;
  filters = null;
  @wire(LabelsAdapter, {
    locales,
  })
  labels = {};
  get supportsFilters() {
    switch (this.config.learning.type) {
      case "MODULE":
      case "PROJECT":
      case "TRAIL":
        return true;
      default:
        return false;
    }
  }
  get stencils() {
    return [1, 2, 3];
  }
  handleRequestClose() {
    this.dispatchEvent(new CustomEvent("requestclose"));
  }
  @wire(QueryAdapter, {
    options: "$queryOptions",
  })
  onResult(result) {
    if (result.error) {
      console.log(result.error);
    } else if (result.errors) {
      console.log(result.errors);
    } else if (result.data) {
      let filters =
        result.data?.findBadge?.filters ??
        result.data?.findTrail?.filters ??
        [];
      this.filters = filters.map((filter) => {
        let summaryType = pluralizeLearningCollectionType(
          this.config.learning.type
        );
        let type = filter.type.toLowerCase();
        if (type === "skill") type = "tag";
        return {
          href: `/${summaryType}#${type}=${type}-${filter.name}`,
          id: filter.id,
          title: filter.label,
        };
      });
    }
  }
  get queryOptions() {
    let type = this.config.learning.type;
    switch (type) {
      case "MODULE":
      case "PROJECT":
        return {
          query,
          variables: {
            name: this.config.learning.name,
            type: this.config.learning.type,
          },
        };
      case "TRAIL":
        return {
          query: trailQuery,
          variables: {
            learning: {
              name: this.config.learning.name,
            },
          },
        };
      default:
        return undefined;
    }
  }
}
const query = gql`
  query ThDetailsModalBadge($name: String!, $type: BadgeKind!) {
    findBadge(learning: { name: $name, type: $type }) {
      __typename
      ... on LearningDetail {
        filters {
          id
          name
          label
          type
          __typename
        }
      }
    }
  }
`;
const trailQuery = gql`
  query ThDetailsModalTrail($learning: TrailInput!) {
    findTrail(learning: $learning) {
      __typename
      filters {
        id
        name
        label
        type
        __typename
      }
    }
  }
`;

export default detailsModal;
export { query, trailQuery };
